export default {
  current: null,
  jobs: [],
}
